function StartLeftColumn() {

  return (
    <div class='start-left-column'>
      <div class='image-background start-image'></div>
    </div>
  );
}

export default StartLeftColumn;